import request from '@/utils/request6'

// 删除商户号配置
export function deleteMultiMerchant(id) {
  return request({
    url: `/cloud/pay/merchant/config/${id}`,
    method: 'delete'
  })
}

// 分页查询商户号配置列表
export function getMultiMerchantList(params) {
  return request({
    url: '/cloud/pay/merchant/config/page',
    method: 'get',
    params
  })
}

// 查询商户号收款配置列表
export function getMultiMerchantPaymentConfigList(params) {
  return request({
    url: '/cloud/pay/merchant/payment/config/selectList',
    method: 'get',
    params
  })
}

// 修改收款模式配置
export function editMultiMerchantConfigDetail(data) {
  return request({
    url: `/cloud/pay/payment/model/config`,
    method: 'put',
    data
  })
}

// 根据机构ID查询收款模式配置
export function getMultiMerchantConfigDetail() {
  return request({
    url: `/cloud/pay/payment/model/config`,
    method: 'get'
  })
}

// 批量更新商户号收款配置
export function batchUpdateMultiMerchantConfigDetail(data) {
  return request({
    url: `/cloud/pay/merchant/payment/config/updateBatch`,
    method: 'post',
    data
  })
}

export function saveMerchantRoundGoods(data) {
  console.log('保存选中商品作为轮询商品' + data.goodsIds)
  return request({
    url: '/cloud/pay/merchant/payment/config/saveMerchantRoundGoods',
    method: 'post',
    data: data.goodsIds
  })
}

// 根据商户号查询关联的轮询商品
export function getRoundGoodsByMchId(mchId) {
  return request({
    url: `/cloud/pay/round-merchant-business/by-mch-id`,
    method: 'get',
    params: { mchId }
  })
}

// 根据商品ID查询关联的商户号
export function getRoundMerchantByBusinessId(businessId) {
  return request({
    url: `/cloud/pay/round-merchant-business/by-business-id`,
    method: 'get',
    params: { businessId }
  })
}

export function cancelMerchantToBusinessData(data) {
  return request({
    url: '/cloud/pay/round-merchant-business/cancelMerchantToBusinessData',
    method: 'post',
    data: data
  })
}

export function saveBusinessDataToMerchant(data) {
  return request({
    url: '/cloud/pay/round-merchant-business/saveBusinessDataToMerchant',
    method: 'post',
    data: data
  })
}